// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/zoom-out.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/add-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_searches{
    display: flex;
    align-items: center;
    gap: 8px;
}

.dashboard_searches_search{
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px solid #D6DFF6;
    padding: 12px;
    border-radius: 30px;
    width: 100%;
}


.dashboard_searches_search--focus{
    border: 1px solid #535353;
}

.dashboard_searches_search_icon{
    width: 20px;
    height: 20px;
    border-radius: 100%;
    /*background-color: #0009;*/
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.dashboard_searches_search_input{
    border: none;
    width: 100%;
}

.dashboard_searches_search_input{
    outline: none;
}

.dashboard_searches_add{
    height: 100%;
    aspect-ratio: 1;
    padding: 23px;
    border-radius: 100%;
    flex-shrink: 0;
    border: 1px solid #D6DFF6;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 21px;
    background-position: center;
    background-repeat: no-repeat;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/DashboardSearches.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;;IAEd,yDAAkD;IAClD,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,yBAAyB;;IAEzB,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC","sourcesContent":[".dashboard_searches{\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.dashboard_searches_search{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    border: 1px solid #D6DFF6;\n    padding: 12px;\n    border-radius: 30px;\n    width: 100%;\n}\n\n\n.dashboard_searches_search--focus{\n    border: 1px solid #535353;\n}\n\n.dashboard_searches_search_icon{\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    /*background-color: #0009;*/\n    flex-shrink: 0;\n\n    background-image: url('../../assets/zoom-out.svg');\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.dashboard_searches_search_input{\n    border: none;\n    width: 100%;\n}\n\n.dashboard_searches_search_input{\n    outline: none;\n}\n\n.dashboard_searches_add{\n    height: 100%;\n    aspect-ratio: 1;\n    padding: 23px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    border: 1px solid #D6DFF6;\n\n    background-image: url('../../assets/add-circle.svg');\n    background-size: 21px;\n    background-position: center;\n    background-repeat: no-repeat;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
